/* Koforto 通用图库滑动：任何 [data-gallery]（主图 [data-gallery-main] + .thumbs 里带 data-src 的按钮）
 * - 主图区改为原生横向滑动（scroll-snap）：手指跟随、松手吸附，手机/触控板都能滑
 * - 电脑：鼠标悬停时左右箭头；手机：底部圆点
 * - 缩略图：点击滑到对应图片；图片多于一行时缩略图行可横向滚动（不限张数）
 * - 选择器换颜色（kf:change）时，自动滑到该变体的图片（与商品图同一张才会匹配）
 * 原主图 <img> 保留但隐藏，兼容旧脚本（kf-landing.js / kf-bl.js）对它的写入。
 * 用法：页面里加载本脚本即可，无需改图库结构。多次加载也只初始化一次。
 */
(() => {
  if (window.__kfGallerySwipe) return; window.__kfGallerySwipe = true;
  const css = `
  [data-gallery-main].kfg-on{overflow:hidden}
  [data-gallery-main].kfg-on>img,[data-gallery-main].kfg-on>picture,[data-gallery-main].kfg-on>span{visibility:hidden}
  .kfg-track{position:absolute;inset:0;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scroll-behavior:smooth;scrollbar-width:none;-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain;border-radius:inherit}
  .kfg-track::-webkit-scrollbar{display:none}
  .kfg-slide{flex:0 0 100%;width:100%;height:100%;scroll-snap-align:center;scroll-snap-stop:always}
  .kfg-slide img{display:block;width:100%;height:100%;object-fit:var(--kfg-fit,cover);border-radius:inherit;-webkit-user-drag:none;user-select:none}
  .kfg-nav{position:absolute;top:50%;z-index:2;width:40px;height:40px;margin-top:-20px;border:0;border-radius:50%;background:rgba(255,255,255,.88);color:#222;box-shadow:0 2px 10px rgba(0,0,0,.12);display:flex;align-items:center;justify-content:center;cursor:pointer;opacity:0;transition:opacity .15s}
  .kfg-nav svg{width:18px;height:18px}
  .kfg-prev{left:12px}.kfg-next{right:12px}
  [data-gallery-main]:hover .kfg-nav,.kfg-nav:focus-visible{opacity:1}
  .kfg-dots{position:absolute;left:0;right:0;bottom:10px;z-index:2;display:none;justify-content:center;gap:6px;pointer-events:none}
  .kfg-dots i{width:7px;height:7px;border-radius:50%;background:rgba(255,255,255,.6);box-shadow:0 0 0 1px rgba(0,0,0,.08);transition:width .2s}
  .kfg-dots i.on{background:#fff;width:18px;border-radius:99px}
  [data-gallery] .thumbs.kfg-thumbs{display:flex;grid-template-columns:none;overflow-x:auto;scrollbar-width:none;scroll-snap-type:x proximity}
  [data-gallery] .thumbs.kfg-thumbs::-webkit-scrollbar{display:none}
  [data-gallery] .thumbs.kfg-thumbs>button{flex:0 0 calc((100% - 40px) / 5);scroll-snap-align:start}
  @media (hover:none),(max-width:749px){.kfg-nav{display:none}.kfg-dots{display:flex}}`;
  const st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  const arrow = (d) => `<svg viewBox="0 0 20 20" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="${d}"/></svg>`;
  // 同一张图在不同尺寸下 URL 不同，按文件名比较
  const key = (u) => { try { return new URL(u, location.href).pathname.split('/').pop().replace(/_\d+x\d*(?=\.)/, ''); } catch (e) { return ''; } };

  const init = (g) => {
    if (g.__kfg) return;
    const main = g.querySelector('[data-gallery-main]');
    const thumbsWrap = g.querySelector('.thumbs');
    const thumbs = thumbsWrap ? [...thumbsWrap.querySelectorAll('button[data-src]')] : [];
    if (!main || thumbs.length < 2) return;
    g.__kfg = true;
    if (getComputedStyle(main).position === 'static') main.style.position = 'relative';
    const orig = main.querySelector(':scope > img');
    if (orig) main.style.setProperty('--kfg-fit', getComputedStyle(orig).objectFit || 'cover');
    const alt = orig ? orig.alt : '';

    const track = document.createElement('div'); track.className = 'kfg-track';
    thumbs.forEach((b, i) => {
      const s = document.createElement('div'); s.className = 'kfg-slide';
      const im = document.createElement('img'); im.src = b.dataset.src; im.alt = alt; im.draggable = false;
      // 手机不再下载 1400px 大图：按屏幕宽度挑合适尺寸（Shopify 图片 URL 带 width 参数时生效）
      if (/[?&]width=\d+/.test(b.dataset.src)) { im.srcset = [600, 900, 1400].map((w) => b.dataset.src.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w').join(', '); im.sizes = '(min-width: 990px) 55vw, 100vw'; }
      im.loading = i === 0 ? 'eager' : 'lazy'; im.decoding = 'async';
      s.appendChild(im); track.appendChild(s);
    });
    const dots = document.createElement('div'); dots.className = 'kfg-dots';
    dots.innerHTML = thumbs.map(() => '<i></i>').join('');
    let idx = Math.max(0, thumbs.findIndex((b) => b.getAttribute('aria-current') === 'true'));
    const paint = (i) => {
      idx = i;
      thumbs.forEach((b, k) => { if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      [...dots.children].forEach((d, k) => d.classList.toggle('on', k === i));
      const b = thumbs[i];
      if (b && thumbsWrap.scrollWidth > thumbsWrap.clientWidth) {
        const l = b.offsetLeft - thumbsWrap.offsetLeft, r = l + b.offsetWidth;
        if (l < thumbsWrap.scrollLeft || r > thumbsWrap.scrollLeft + thumbsWrap.clientWidth) thumbsWrap.scrollTo({ left: l - 8, behavior: 'smooth' });
      }
    };
    const to = (i, smooth = true) => {
      i = (i + thumbs.length) % thumbs.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      paint(i);
    };
    const mk = (cls, d, step, label) => { const b = document.createElement('button'); b.type = 'button'; b.className = `kfg-nav ${cls}`; b.setAttribute('aria-label', label); b.innerHTML = arrow(d); b.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); to(idx + step); }); return b; };
    main.append(track, mk('kfg-prev', 'M12.5 4l-6 6 6 6', -1, 'Previous image'), mk('kfg-next', 'M7.5 4l6 6-6 6', 1, 'Next image'), dots);
    main.classList.add('kfg-on');
    thumbsWrap.classList.add('kfg-thumbs');
    paint(idx);
    if (idx) requestAnimationFrame(() => to(idx, false));

    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => { const i = Math.round(track.scrollLeft / (track.clientWidth || 1)); if (i !== idx && i >= 0 && i < thumbs.length) paint(i); });
    }, { passive: true });
    // 缩略图点击：滑到对应图（捕获阶段，旧脚本仍会改隐藏的原图，不影响）
    thumbs.forEach((b, i) => b.addEventListener('click', () => to(i)));
    window.addEventListener('resize', () => track.scrollTo({ left: idx * track.clientWidth, behavior: 'auto' }));

    // 选择器换颜色：滑到该变体图片
    const scope = g.closest('section, .buy, .order, .offer') || document;
    scope.addEventListener('kf:change', (e) => {
      const vs = (e.detail && e.detail.variants) || [];
      const v = vs[vs.length - 1]; if (!v || !v.image) return;
      const k = key(v.image); if (!k) return;
      const i = thumbs.findIndex((b) => key(b.dataset.src) === k);
      if (i > -1 && i !== idx) to(i);
    });
  };
  const run = () => document.querySelectorAll('[data-gallery]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
